import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'
import { setAlpha } from 'tools/style'
import Icon from 'decorators/Icon'

/*
  Custom color --> colour 1: props.color, color 2: 50% opacity button-color
  When used in forms --> colour 1: button-color, colour2: 50% opacity button-color --> (primary)
  When used in buttons --> colour 1: button-text, colour2: 50% opacity button-text --> (secondary)
*/

// primary -> used in form
// secondary -> used in button

const getColorOne = ({ color, theme, secondary }) => {
  if (color) return color
  if (secondary) {
    return theme.buttonTextColor
  } else {
    return theme.buttonColor
  }
}

const getColorTwo = ({ color, theme, secondary }) => {
  if (color) return setAlpha(color)
  if (secondary) {
    return setAlpha(theme.buttonTextColor)
  } else {
    return setAlpha(theme.buttonColor)
  }
}

// eslint-disable-next-line react/prop-types
const IconSpinner = ({ t, className, height, width, fill, theme, color, secondary }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 60 60'>
    <title>{t('Spinner')}</title>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M30 60C13.458 60 0 46.542 0 30S13.458 0 30 0s30 13.458 30 30a30.23 30.23 0 0 1-.584 5.914 4 4 0 1 1-7.844-1.569c.284-1.42.428-2.882.428-4.345 0-12.131-9.87-22-22-22S8 17.869 8 30c0 12.13 9.87 22 22 22 1.874 0 3.735-.236 5.53-.7a4 4 0 0 1 2.004 7.745C35.084 59.679 32.55 60 30 60'
        fill={getColorOne({ color, theme, secondary })}
      />
      <path
        d='M54.71 39.052a3.997 3.997 0 0 1-3.21-4.021c-1.813 7.745-7.71 13.933-15.29 16.158a3.998 3.998 0 0 1 4.195 2.982 3.997 3.997 0 0 1-2.313 4.68c10.565-2.968 18.782-11.589 21.167-22.383a3.994 3.994 0 0 1-4.55 2.584'
        fill={getColorTwo({ color, theme, secondary })}
      />
    </g>
  </svg>
)
IconSpinner.propTypes = {
  secondary: PropTypes.bool,
  color: PropTypes.string
}
IconSpinner.defaultProps = {
  theme: {
    buttonColor: '#19698C',
    buttonTextColor: '#C6DCE6'
  }
}

export default Icon(withTheme(IconSpinner))
